import {
    Box,
    useTheme,
    Stack
} from "@mui/material";
import LiveSearch from "../LiveSearch/LiveSearch";
import Content from "./Content";
import Header from "./Header";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const GlobalLiveSearch = ({ handleBack=null, value="", content=null, sx }) => {
    const theme = useTheme();
    const params = useParams();

    const backButton = handleBack ? true : false
    const [openObject, setOpenObject] = useState({})

    const handleClick = (object) => {
        setOpenObject(object)
    };

    useEffect(() => {
        switch(params.object) {
            case 'user':
                setOpenObject({
                    'object_type': params.object,
                    'object': params.source + ":" + params.id,
                });
                break;
            case 'host': 
                setOpenObject({
                    'object_type': params.object,
                    'object': params.source + ":" + params.id,
                });
                break;
            default:
                setOpenObject(content)
        }
    }, [ content, params.id, params.object, params.source ]);

    // useEffect(() => {
    //     setOpenObject(content)
    // },[content]);

    return (
        <Stack 
            spacing={2} 
            sx={{...sx}}>
            {backButton && <Header handleBack={handleBack}/>}
            <Stack sx={{ width: "100%"}}>
                <LiveSearch 
                    value={value}
                    handleClick={handleClick}
                />
            </Stack>
            <Content 
                content={openObject}
            />
        </Stack>
    );
};

export default GlobalLiveSearch;